module.exports = __webpack_public_path__ + "static/media/icon_view_left.6383c776.svg";